import React from 'react';
import cn from 'classnames';
import { DotIcon } from '../../Icons';

export interface BulletListProps {
  items: React.ReactNode[];
  variant?: 'default' | 'inverse';
  className?: string;
}

const textColorMap = {
  default: 'text-ds-text-1',
  inverse: 'text-ds-text-inverse-1',
};

export const BulletList: React.FC<BulletListProps> = ({
  items,
  variant = 'default',
  className,
}) => (
  <ul className={cn('flex flex-col gap-3', className)}>
    {items.map((item, i) => (
      <li key={i} className="flex items-center gap-1 w-full shrink-0 list-none">
        <DotIcon className="text-ds-bg-surface-2 shrink-0" />
        <span className={cn('flex-1 text-ds-text', textColorMap[variant])}>{item}</span>
      </li>
    ))}
  </ul>
);

export default BulletList;
